import { render, staticRenderFns } from "./AppointmentPracticeSplitSlot.vue?vue&type=template&id=2e3faf49&"
import script from "./AppointmentPracticeSplitSlot.vue?vue&type=script&lang=ts&"
export * from "./AppointmentPracticeSplitSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports